/**
 * URL paths
 * They will be appended to the domain name of each environment.
 */
export const ROUTE = {
  CREATE_ACCOUNT_ENDPOINT: '/auth/register',
  SIM_ONLY_PAGE_REDIRECT: '/sim-only/redirect',
  KEEP_NUMBER_PAGE_REDIRECT: '/sim-onboarding/keep-number',
  KEEPING_NUMBER_PAGE_REDIRECT: '/sim-onboarding/keeping-number',
} as const

/**
 * URLs used across all envs.
 * They must be started with absolute URL (https://...).
 * e.g. Help page doesn't have STG. So all environments use PRD URL.
 */
export const URL = {
  DEFAULT_AVATAR:
    'https://giffgaff.com/styleguide/svg/gamification/avatar_default.svg',
} as const

/**
 * Portal auth paths the header links to.
 */
export const AUTH_URL = {
  DASHBOARD: '/dashboard',
  LOG_IN: '/auth/login',
  LOG_OUT: '/auth/logout',
} as const

export const STYLES = {
  MIN_CONTAINER_HEIGHT: 600,
} as const
